import { Icon, message, Modal, Upload } from 'antd';
import { RcCustomRequestOptions, UploadFile } from 'antd/lib/upload/interface';
import React from 'react';
import FlexApiService, { IBucketInfo } from 'src/services/FlexApiService';
import { getBase64 } from 'src/utils/upload';
import uuid from 'uuid';

interface FlexUploadProps {
  value?: string[];
  disabled?: boolean;
  /** 显示文字 */
  showText?: string;
  listType?: 'text' | 'picture' | 'picture-card',
  onChange?: (value: any) => void;
}

interface FlexUploadState {
  loading: boolean;
  fileList: UploadFile[],
  previewVisible: boolean,
  previewImage: string,
}

let bucket: IBucketInfo | undefined;

/**
 * 使用 flex模式 图片上传组件
 */
class FlexUpload extends React.Component<FlexUploadProps, FlexUploadState> {
  private flexService = FlexApiService;
  constructor(props: FlexUploadProps) {
    super(props);
    this.state = {
      loading: false,
      fileList: [],
      previewVisible: false,
      previewImage: '',
    };
  }

  componentDidMount() {
    const { value } = this.props;
    const fileList: UploadFile[] = [];
    if (value) {
      value.forEach(item => {
        const fileItem = {
          uid: uuid.v4(),
          url: item,
          preview: item,
          status: 'done',
        } as UploadFile;
        fileList.push(fileItem);
      });
    }
    this.setState({ fileList });
  }


  beforeUpload = (file: File) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      message.error('抱歉，只能上传JPG或PNG图片!');
    }
    return isJpgOrPng;
  }

  handleCancel = () => this.setState({ previewVisible: false });

  handlePreview = async (file: UploadFile) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj as Blob);
    }

    this.setState({
      previewImage: file.url || file.preview || '',
      previewVisible: true,
    });
  };

  handleRemove = (file: UploadFile) => {
    const { onChange } = this.props;
    const { fileList } = this.state;
    const restFiles = fileList.filter(item => item.url && item.url !== file.url);
    this.setState({ fileList: restFiles });
    if (onChange) {
      const filePaths = restFiles.map(item => item.url);
      onChange(filePaths);
    }
  };

  handleCustomRequest = async (options: RcCustomRequestOptions) => {
    const { onChange } = this.props;
    this.setState({ loading: true });
    try {
      if (!bucket) {
        bucket = await this.flexService.createBucket({
          bucket_type: 'mc_wallet_pic',
          intro: { name: 'macrocura wallet register pictures' },
        });
      }
      if (bucket) {
        const submitFile = options.file;
        const res = await this.flexService.uploadJumpLinkPic(bucket, submitFile);
        if (!!res) {
          const newFiles: UploadFile[] = [{
            uid: uuid.v4(),
            url: res,
            preview: res,
            status: 'done',
            size: submitFile.size,
            type: submitFile.type,
            name: submitFile.name,
          }];
          this.setState({ fileList: newFiles });
          if (onChange) {
            const filePaths = newFiles.map(item => item.url);
            onChange(filePaths);
          }
        } else {
          message.error('上传照片失败了!');
        }
      } else {
        message.error('上传照片失败了!');
      }
    } catch (error) {
      message.error('出错了');
    }
    this.setState({ loading: false });
  }

  render() {
    const {
      showText,
      disabled,
      listType,
      onChange,
    } = this.props;
    const {
      loading,
      fileList,
      previewVisible,
      previewImage,
    } = this.state;

    const uploadButton = (
      <div>
        <Icon type={loading ? 'loading' : 'plus'} />
        <div style={{ marginTop: 10 }} className="ant-upload-text">{showText || '上传'}</div>
      </div>
    )
    return (
      <div>
        <Upload
          fileList={fileList}
          disabled={disabled}
          listType={listType || 'picture-card'}
          beforeUpload={this.beforeUpload}
          onPreview={this.handlePreview}
          onRemove={this.handleRemove}
          customRequest={this.handleCustomRequest}
        >
          {fileList.length >= 1 ? null : uploadButton}
        </Upload>
        <Modal
          width={800}
          centered={true}
          visible={previewVisible}
          footer={null}
          onCancel={this.handleCancel}
        >
          <img style={{ width: '100%' }} src={previewImage} />
        </Modal>
      </div>
    )
  }
}

export default FlexUpload;


// WEBPACK FOOTER //
// ./src/components/common/FlexUpload.tsx